import { Outlet } from "react-router-dom";
import { BrandedAuthShell } from "@/components/auth/BrandedAuthShell";

export function AccountLayout() {
  return (
    <BrandedAuthShell>
      <Outlet />
    </BrandedAuthShell>
  );
}
